export default __webpack_public_path__ + "static/media/homme.9f3edb31.png";